module.exports = __webpack_public_path__ + "img/jon_smith_5.5aa4a3fd.png";